// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g7VQBHFIS2_ph9JJvi8T {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
}

.oA9348FsrQUFvFRQD251 {
  overflow-y: auto;
  height: calc(100vh - 18rem);
}

.ctgyBC44VuMEpCmHdSvc {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.kBCM0KtnTxtIrE7LNu2X {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/screens/TutorialAdministration/Tutorials.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAF","sourcesContent":["\r\n.tutorialAdminContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: white;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.tutorialTableContainer {\r\n  overflow-y: auto;\r\n  height: calc(100vh - 18rem);\r\n}\r\n\r\n.tutorialTableFooter {\r\n  width: 100%;\r\n  height: 50px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.edittutorialContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tutorialAdminContainer": `g7VQBHFIS2_ph9JJvi8T`,
	"tutorialTableContainer": `oA9348FsrQUFvFRQD251`,
	"tutorialTableFooter": `ctgyBC44VuMEpCmHdSvc`,
	"edittutorialContainer": `kBCM0KtnTxtIrE7LNu2X`
};
export default ___CSS_LOADER_EXPORT___;
